import React from 'react';
import ReactDOM from 'react-dom';
import MainRouter from './modules/MainRouter';

ReactDOM.render(<MainRouter />, document.getElementById('app-root'));



// WEBPACK FOOTER //
// ./src/index.js